import type { IconData } from '@stacksjs/iconify-core'

export const volumeLevelHigh: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linejoin=\"round\" stroke-width=\"3\"><path stroke-linecap=\"round\" d=\"M40 12c6.667 6.627 6.667 17.373 0 24m-5-20c4 4.418 4 11.582 0 16\"/><path d=\"M28.352 7.194c-.157-1.732-1.801-2.88-3.439-2.294C17.248 7.642 11 13.5 11 13.5s-2.752.611-5.147 1.356a3.28 3.28 0 0 0-2.273 2.558A37.4 37.4 0 0 0 3 24c0 2.768.307 5.076.58 6.585a3.28 3.28 0 0 0 2.273 2.558C8.248 33.888 11 34.5 11 34.5s6.248 5.858 13.913 8.6c1.638.586 3.282-.562 3.439-2.294c.288-3.2.648-8.801.648-16.806s-.36-13.607-.648-16.806Z\"/><path stroke-linecap=\"round\" d=\"M11 13.5s-.5 4.786-.5 10.5s.5 10.5.5 10.5\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default volumeLevelHigh
